import React, { useContext, useEffect } from "react";
import styles from './RecommendationBlock.module.scss'
import RecommendationsCarousel from "Containers/RecommendationsCarousel";
import RecommendationsGrid from "Containers/RecommendationsGrid";
import RecommendationsVertical from "Containers/RecommendationsVertical";
import RecommendationsCard from "../../Containers/RecommendationsCard/RecommendationsCard";
import Card from "Atoms/Card";
import classNames from "classnames";
import RecommendationsCompare from "../../Containers/RecommendationsCompare/RecommendationsCompare";

const RecommendationBlock = ({
  recBlock,
  dataTestId,
  index,
  id,
  numberOfSkeletons,
  numberOfSkeletonSections,
  skeletonDisplayType,
  skeletonType,
  displayType,
  isCard,
  isExpandable,
  isLoading,
  useDivider,
  useSubtitle,
  useItemCount,
  leftAlignCarousel,
  horizontalCard,
  cardDisplayType,
  showCarouselGradient,
  extendGuttersForCarousel,
  className,
  treatment,
}) => {
  displayType = (displayType || recBlock?.displayType)?.toLowerCase();

  if (!recBlock?.recommendations?.length) {
    return false;
  } else {
    return (
      (isCard) ?
        <Card fill className={classNames(className, styles.card)}>
          <RecommendationBlockBase
            recBlock={recBlock}
            dataTestId={dataTestId}
            index={index}
            id={id}
            isLoading={isLoading}
            numberOfSkeletons={numberOfSkeletons}
            numberOfSkeletonSections={numberOfSkeletonSections}
            skeletonDisplayType={skeletonDisplayType}
            skeletonType={skeletonType}
            isExpandable={isExpandable}
            displayType={displayType}
            useDivider={useDivider}
            useSubtitle={useSubtitle}
            useItemCount={useItemCount}
            leftAlignCarousel={leftAlignCarousel}
            horizontalCard={horizontalCard}
            cardDisplayType={cardDisplayType}
            showCarouselGradient={showCarouselGradient}
            extendGuttersForCarousel={extendGuttersForCarousel}
            treatment={treatment}
          />
        </Card>
        :
        <RecommendationBlockBase
          recBlock={recBlock}
          dataTestId={dataTestId}
          index={index}
          id={id}
          isLoading={isLoading}
          skeletonDisplayType={skeletonDisplayType}
          numberOfSkeletons={numberOfSkeletons}
          numberOfSkeletonSections={numberOfSkeletonSections}
          skeletonType={skeletonType}
          isExpandable={isExpandable}
          displayType={displayType}
          useDivider={useDivider}
          useSubtitle={useSubtitle}
          useItemCount={useItemCount}
          className={className}
          leftAlignCarousel={leftAlignCarousel}
          horizontalCard={horizontalCard}
          cardDisplayType={cardDisplayType}
          showCarouselGradient={showCarouselGradient}
          extendGuttersForCarousel={extendGuttersForCarousel}
          treatment={treatment}
        />
    )
  }
};

const RecommendationBlockBase = ({
  recBlock,
  dataTestId,
  index,
  id,
  skeletonDisplayType,
  numberOfSkeletons,
  numberOfSkeletonSections,
  skeletonType,
  displayType,
  isExpandable,
  isLoading,
  useDivider,
  useSubtitle,
  useItemCount,
  horizontalCard,
  leftAlignCarousel,
  cardDisplayType,
  showCarouselGradient,
  extendGuttersForCarousel,
  className,
  treatment
}) => {

  displayType = displayType?.toLowerCase()

  if (displayType == "grid") {
    return <RecommendationsGrid
      recBlock={recBlock}
      dataTestId={dataTestId}
      blockIndex={index}
      isLoading={isLoading}
      skeletonDisplayType={skeletonDisplayType}
      numberOfSkeletons={numberOfSkeletons}
      numberOfSkeletonSections={numberOfSkeletonSections}
      skeletonType={skeletonType}
      isExpandable={isExpandable}
      useDivider={useDivider}
      useSubtitle={useSubtitle}
      useItemCount={useItemCount}
      horizontalCard={horizontalCard}
      className={className}
      treatment={treatment}
    />
  } else if (displayType == "vertical") {
    return <RecommendationsVertical
      recBlock={recBlock}
      dataTestId={dataTestId}
      blockIndex={index}
      isLoading={isLoading}
      skeletonDisplayType={skeletonDisplayType}
      numberOfSkeletons={numberOfSkeletons}
      numberOfSkeletonSections={numberOfSkeletonSections}
      isExpandable={isExpandable}
      useDivider={useDivider}
      useSubtitle={useSubtitle}
      useItemCount={useItemCount}
      className={className}
      treatment={treatment}
    />
  } else if (displayType == "card") {
    return <RecommendationsCard
      recBlock={recBlock}
      dataTestId={dataTestId}
      blockIndex={index}
      isLoading={isLoading}
      skeletonDisplayType={skeletonDisplayType}
      numberOfSkeletons={numberOfSkeletons}
      numberOfSkeletonSections={numberOfSkeletonSections}
      isExpandable={isExpandable}
      useDivider={useDivider}
      useSubtitle={useSubtitle}
      useItemCount={useItemCount}
      horizontalCard={horizontalCard}
      cardDisplayType={cardDisplayType}
      treatment={treatment}
    />
  } else if (displayType == "comparison") {
    return <RecommendationsCompare
      recBlock={recBlock}
      dataTestId={dataTestId}
      blockIndex={index}
      displayType={displayType}
      isLoading={isLoading}
      skeletonDisplayType={skeletonDisplayType}
      numberOfSkeletons={numberOfSkeletons}
      numberOfSkeletonSections={numberOfSkeletonSections}
      treatment={treatment}
    />
  } else {
    return <RecommendationsCarousel
      recBlock={recBlock}
      dataTestId={dataTestId}
      blockIndex={index}
      id={id}
      isLoading={isLoading}
      skeletonDisplayType={skeletonDisplayType}
      numberOfSkeletons={numberOfSkeletons}
      numberOfSkeletonSections={numberOfSkeletonSections}
      skeletonType={skeletonType}
      useDivider={useDivider}
      useSubtitle={useSubtitle}
      useItemCount={useItemCount}
      horizontalCard={horizontalCard}
      leftAlignCarousel={leftAlignCarousel}
      showCarouselGradient={showCarouselGradient}
      extendGuttersForCarousel={extendGuttersForCarousel}
      className={className}
      treatment={treatment} />
  }
};

const recBottomSpacing = (BaseComponent) => (props) => <BaseComponent {...props} className={classNames(props.className, styles.bottomPadding)} />

export default recBottomSpacing(RecommendationBlock);